import React, { Component } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import CircularProgress from "@material-ui/core/CircularProgress";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import TimetableGrid from "components/Timetable/TimetableGrid.jsx";

import api from "api/index";

const styles = {
  filterSelect: { padding: "8px 12px", border: "1px solid #ddd", borderRadius: "4px", fontSize: "13px", minWidth: "220px" },
  emptyState: { textAlign: "center", color: "#999", padding: "40px" }
};

class PortalTimetable extends Component {
  state = { semesters: [], selectedSemester: "", timetable: [], loading: false, loadingSemesters: true };

  componentDidMount() {
    this.fetchSemesters();
  }

  fetchSemesters = async () => {
    try {
      const res = await api.get("/portal/semesters");
      const list = res.data.data || res.data;
      const current = list.find(s => s.isCurrent) || list[0];
      this.setState(
        { semesters: list, selectedSemester: current ? String(current.id) : "", loadingSemesters: false },
        () => { if (this.state.selectedSemester) this.fetchTimetable(); }
      );
    } catch (e) {
      this.setState({ loadingSemesters: false });
    }
  };

  fetchTimetable = async () => {
    const { selectedSemester } = this.state;
    if (!selectedSemester) return;
    this.setState({ loading: true });
    try {
      const res = await api.get("/portal/timetable", { params: { semesterId: selectedSemester } });
      const d = res.data.data || res.data;
      this.setState({ timetable: Array.isArray(d) ? d : d.data || [], loading: false });
    } catch (e) {
      this.setState({ timetable: [], loading: false });
    }
  };

  handleSemesterChange = e => {
    this.setState({ selectedSemester: e.target.value }, this.fetchTimetable);
  };

  render() {
    const { classes } = this.props;
    const { semesters, selectedSemester, timetable, loading, loadingSemesters } = this.state;

    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" style={{ margin: -8, padding: "24px 20px" }}>
              <h4 style={{ margin: 0, color: "#fff", fontWeight: "bold" }}>My Timetable</h4>
              <p style={{ margin: "2px 0 0", color: "rgba(255,255,255,0.8)", fontSize: "13px" }}>
                Weekly schedule for your enrolled courses
              </p>
            </CardHeader>
            <CardBody>
              <div style={{ marginBottom: "20px" }}>
                <label style={{ fontSize: "12px", color: "#666", display: "block", marginBottom: "4px" }}>Semester</label>
                {loadingSemesters ? (
                  <CircularProgress size={20} />
                ) : (
                  <select className={classes.filterSelect} value={selectedSemester} onChange={this.handleSemesterChange}>
                    <option value="">— Select Semester —</option>
                    {semesters.map(s => (
                      <option key={s.id} value={String(s.id)}>{s.name || `Semester ${s.id}`}</option>
                    ))}
                  </select>
                )}
              </div>

              {!selectedSemester ? (
                <p className={classes.emptyState}>Select a semester to view your timetable.</p>
              ) : loading ? (
                <div style={{ textAlign: "center", padding: "40px" }}><CircularProgress /></div>
              ) : (
                <TimetableGrid entries={timetable} emptyMessage="No timetable entries for your enrolled courses this semester." />
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

PortalTimetable.propTypes = { classes: PropTypes.object.isRequired };
export default withStyles(styles)(PortalTimetable);
